import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMemberQuery = createQueryHook(MembershipsCreatorApiClient.getMember, {
  queryKey: ['member'],
})
